<template>
  <div class="home-content">
    <div class="head-select">
      <el-select clearable
        v-model="selecttype"
        placeholder="预约事项"
        class="search-select"
      >
        <el-option
          v-for="item in resultList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select> 
			<el-date-picker
        v-model="timer1"
        type="date"
        placeholder="选择日期">
      </el-date-picker>           
      <el-button type="primary" class="search-button" @click="search">
        <img src="@/assets/icon/search.png" alt="" class="button-icon" />
        查询
      </el-button>
      <el-button type="primary" class="search-button" @click="todp">
        前往大屏
      </el-button>
      <!-- <el-button type="primary" class="add-button" @click="add">
        新增
      </el-button>
      <el-button type="danger" class="del-button" @click="delMulti">
        删除
      </el-button> -->
    </div>
    <div class="machine-content">
      <div class="list-con">
        <el-table
          ref="filterTable"
          :data="tabelData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="id" label="ID" width="55"> </el-table-column>
          <el-table-column
            :prop="item.key"
            :label="item.label"
            v-for="item in dataSource"
            :key="item.key"
          >
            <template slot-scope="scope">
              <div class="text" v-if="!slotmap.includes(item.key)">
                {{ scope.row[item.key] }}
              </div>
              <div class="text" v-else-if="item.key == 'row_type'">
                {{ checkType(scope.row[item.key]) }}
              </div>  
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages" style="display:block;height:auto;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="numdata"
        style="margin-top: 30px; float: right; margin-right: 60px"
        :current-page="current_page" 
        :page-size="page_size"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange_prev"
        @next-click="handleCurrentChange_next"
      >
      </el-pagination>
      </div>      
    </div>
    <el-dialog
      :visible.sync="addvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose"
      :destroy-on-close="true" 
      :close-on-click-modal ="false"
      width="720px"
    >
      <div slot="title">{{formData.id>0?"编辑":"新增"}}</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">机器名称</div>
          <el-input
            class="edit-input"
            v-model="formData.name"
            placeholder="请输入机器名称"
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">机器类型</div>
          <el-select class="edit-input"
            v-model="formData.product_id"
            placeholder="请输入所属生产组">
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
          </el-select>
        </div>       
        <div class="edit-item">
          <div class="text">机器编号</div>
          <el-input
            class="edit-input"
            v-model="formData.sn"
            placeholder="请输入机器编号"
          ></el-input>
        </div>
        <div class="edit-item">
          <div class="text">所属生产组</div>
          <el-select class="edit-input"
            v-model="formData.team_id"
            placeholder="请输入所属生产组">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
        </div>
        <div class="edit-item">
          <div class="text">备注</div>
          <el-input
            class="edit-input"
            v-model="formData.remark"
            placeholder="请输入备注"
          ></el-input>
        </div>                
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="adds"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>     
    <el-dialog
      title=""
      :visible.sync="imgDialogVisible"
      width="50%"
      center
    >
      <div class="looks">
        <div class="tt">
          <img src="@/assets/icon/icon_1.jpg" alt="" class="button-icon" />
          <div class="r_txt">
            <span>创建成功</span>
            <label>请点击下方按钮下载二维码</label>
          </div>
        </div>
        <div class="cons" v-if="jsonDialog">
          <div class="cons_l">
            <div class="single">机器名称：</div>
            <div class="single">{{jsonDialog.name}}</div>
            <div class="single">机器类型：</div>
            <div class="single">{{jsonDialog.product_name}}</div>
            <div class="single">机器编号：</div>
            <div class="single">{{jsonDialog.sn}}</div> 
            <div class="single">所属生产组：</div>
            <div class="single">{{jsonDialog["team_name"]}}</div>                
          </div> 
          <div class="cons_r">
            <div class="img_infor">
              <img :src="imgDialogUrl" alt="" />
              <span>复制设备信息</span>
            </div>
          </div>                          
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button style="background:#507AF9" type="primary" @click="downloadImg"
          >下载二维码</el-button
        >
      </span>
    </el-dialog>     
  </div>
</template>

<script>
import { delMachines,getProductLists,editMachines,addMachines,getGrouupLists,reservationLists } from "../../api/index";
export default {
  data() {
    return {
      activeName: "first",
      timer1: "",
      searchval: "",
      selecttype:"",
      selectval:"sn",
      options: [
        { label: "机器编号", value: "sn" },
        { label: "机器名称", value: "name" },
      ],      
      dataSource: [
        { label: "预约时间", key: "create_time" },
        { label: "预约人", key: "users" },
        { label: "预约事项", key: "row_type" },
        { label: "预约原因", key: "content" },
      ],
      tabelData: [],
      slotmap: ["menu","row_type"],
      numdata: 0,
      current_page: 1,
      page_size:15,
      addvisible:false,
      formData:{
        id:0,
        name:"",
        team_id:"",
        sn:"",
        product_id:"",
        remark:"",
      },
      teamList:[],//缝纫机列表
      productList:[],//类型列表
      delList:[],//删除列表
      imgDialogVisible:false,
      imgDialogUrl:"",
      jsonDialog:{},
      imgUrl:"https://fmadmin.sewme.cn",//图片网址
      resultList:[//预约事项
        {
          name:"预约换针",
          id:1
        },
        {
          name:"一键报修",
          id:2
        },					
      ],    
    };
  },
  methods: {  
    //时间戳转换成日期格式
    formatDate(value) {// 时间戳转换日期格式方法
        if (value == null) {
            return '';
        } else {
            value=value*1000
            let date = new Date(value);
            let y = date.getFullYear();// 年
            let MM = date.getMonth() + 1;// 月
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();// 日
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();// 时
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();// 分
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();// 秒
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
    },     
    //预约事项类型
    checkType(val){
      var str="其他"
      if(val==1){
        str="预约换针";
      }else if(val==2){
        str="一键报修";
      }
      return str;
    },    
    downloadImg(){
      this.downloadByBlob(this.imgDialogUrl,'二维码')
    },
    // 下载图片
    downloadByBlob(url, name) {
      let image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = url
      image.onload = () => {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, image.width, image.height)
        canvas.toBlob((blob) => {
          let url = URL.createObjectURL(blob)
          this.download(url, name)
          // 用完释放URL对象
          URL.revokeObjectURL(url)
        })
      }
    },
    download(href, name) {
      let eleLink = document.createElement('a')
      eleLink.download = name
      eleLink.href = href
      eleLink.click()
      eleLink.remove()
    },
    lookImg(row){
      if(!row.image){
        this.$message.warning("暂未生成二维码!");
        return;
      }
      this.imgDialogVisible=true;
      this.jsonDialog=row;
      this.jsonDialog.product_name=this.jsonDialog.product.name;
      this.jsonDialog.team_name=this.jsonDialog.team.name;
      this.imgDialogUrl=this.imgUrl+row.image;
    },   
    delMulti(){
      if(this.delList.length==0){
        this.$message.warning("请选择要删除的缝纫机!");
        return;
      }
      this.$confirm(
        '确认删除选择的缝纫机吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms={
          ids:this.delList,
        }
        delMachines(forms).then(res => {	
          if(res.code==1){
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.delList=[];
            this.getData();
          }else{
            this.$message.warning("删除失败!");
          }					
        });
      }).catch((err) => {
        Message.warning('取消操作');
      }) 
    },    
    delSingle(row){
      this.$confirm(
        '确认删除该缝纫机吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms={
          ids:[row.id],
        }
        delMachines(forms).then(res => {	
          if(res.code==1){
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.getData();
          }else{
            this.$message.warning("删除失败!");
          }					
        });
      }).catch((err) => {
        Message.warning('取消操作');
      }) 
    },    
    getProductList() {
      let params = {
        limit: 1000,
        page: 1,
      };
      getProductLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.productList = res.data;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },      
    //添加修改用户
    adds(){
      if(!this.formData.name){
        this.$message.warning("机器名称不能为空!");
        return;
      } 
      if(!this.formData.product_id){
        this.$message.warning("机器类型不能为空!");
        return;
      }             
      if(!this.formData.sn){
        this.$message.warning("机器编号不能为空!");
        return;
      }
      if(!this.formData.team_id){
        this.$message.warning("请选择所属生产组!");
        return;
      }      
      if(this.formData.id==0){
        addMachines(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("添加成功!");
              this.getData();
            } else {
              this.$message.error("添加失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          }); 
      }else{
        editMachines(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("修改成功!");
              this.getData();
            } else {
              this.$message.error("编辑失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          }); 
      }                     
    },    
    getTeamList() {
      let params = {
        limit: 1000,
        page: 1,
      };
      getGrouupLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.teamList = res.data.list;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },    
    dialogclose(){
      this.addvisible=false;
    },    
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page=val;
      this.getData();
    },
    getData() {
      //let params={limit:this.page_size,page:this.current_page};
      let params={};
      if(this.selecttype){
        if(this.timer1){
          var date = new Date(this.timer1);
          date=date.toLocaleDateString();
          date=date+" 00:00:00,"+date+" 23:59:59";
          date=date.replaceAll("/","-");
          //date="2024-07-01 00:00:00,2024-07-31 00:00:00";
          params = {
            limit: this.page_size,
            page: this.current_page,  
            "search[0][field]": "row_type",
            "search[0][val]": this.selecttype,
            "search[0][operator]": "eq",         
            "search[1][field]": "create_time",
            "search[1][val]": date,
            "search[1][operator]": "RANGE",  
            "search[1][render]": "datetime",                  
          };  
        }else{
          params = {
            limit: this.page_size,
            page: this.current_page,  
            "search[0][field]": "row_type",
            "search[0][val]": this.selecttype,
            "search[0][operator]": "eq",                        
          };  
        }
      }else{
        //this.timer1=date;
        if(this.timer1){
          var date = new Date(this.timer1);
          date=date.toLocaleDateString();
          date=date+" 00:00:00,"+date+" 23:59:59";
          date=date.replaceAll("/","-");          
          params = {
            limit: this.page_size,
            page: this.current_page,  
            "search[1][field]": "create_time",
            "search[1][val]": date,
            "search[1][operator]": "RANGE", 
            "search[1][render]": "datetime",                           
          }; 
          
        }else{
          params = {
            limit: this.page_size,
            page: this.current_page,               
          }; 
        }  
      }       
      reservationLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list;
            for(var i=0;i<this.tabelData.length;i++){
              this.tabelData[i].users=this.tabelData[i].user.mobile;
              this.tabelData[i].create_time=this.formatDate(this.tabelData[i].create_time);
              //this.tabelData[i].machineUser=JSON.parse(this.tabelData[i].extra).username;
            }
            console.log(this.tabelData);
            this.numdata = res.data.total;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.current_page=1;
      this.getData();
    },
    handleClick(active) {},
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delList=[];
      for(var i=0;i<this.multipleSelection.length;i++){
        this.delList.push(this.multipleSelection[i].id);
      }
      
    },
    add() {
      this.addvisible=true;
    },
    del() {},
    edit(row) {
      this.formData={
        id:row.id,
        name:row.name,
        team_id:row.team_id,
        sn:row.sn,
        product_id:row.product_id,
        remark:row.remark,
      };
      this.addvisible=true;
    },
    itemdel() {},
    todp() {
      let token = localStorage.getItem("token")
      let url = 'https://fmadmin.sewme.cn/fmdp/#/?token=' + token
      window.open(url)
    }
  },
  mounted() {
    //this.getProductList();
    //this.getTeamList();
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.home-content {
  height: calc(100% - 64px);
  .head-select {
    padding: 24px 0 24px 42px;
    display: flex;
    align-items: center;
    .el-date-editor {
      margin-right: 0px;
      width: 185px;
    }
  }
  .search-input {
    width: 245px;
  }
  .search-select {
    width: 185px;
    margin-right: 16px;
  }
  .search-button {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fefeff;
    line-height: 14px;
    padding: 10px 20px;
    .button-icon {
      margin-right: 10px;
      width: 15.5px;
      height: 15.5px;
    }
  }
  .add-button {
    margin-left: auto;
  }
  .del-button {
    margin-right: 125px;
  }
  .machine-content {
    padding: 0 28px;
    height: calc(100% - 88px);
    background: #fff;
  }
  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }
  .tab-menu {
    display: flex;
    align-items: center;
    column-gap: 12px;
  }
  .edit {
    cursor: pointer;
    color: #507af9;
  }
  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}
</style>
<style lang="scss">
.list-con {
  padding-top: 30px;
  .el-table__header-wrapper {
    th {
      background: #fafafa;
      color: #0c0c0c;
    }
  }
}
.looks{overflow:hidden;}
.looks .tt{width:90%;margin:0 auto;overflow:hidden;}
.looks .tt img{float:left;height:55px;display:block;margin-top:20px;}
.looks .tt .r_txt{width:80%;float:left;margin-left:20px;}
.looks .tt .r_txt span{color:#2F3338;font-size:24px;display:block;margin:15px 0;margin-top:0px;}
.looks .tt .r_txt label{color:#8F96A0;font-size:24px;display:block;margin:15px 0;}
.looks .cons{overflow:hidden;width:90%;margin:0 auto;background:#F6F7F9;border-radius:5px;margin-top:20px;padding:30px 0;}
.looks .cons .cons_l{float:left;width:50%;overflow:hidden;margin-left:10%;}
.looks .cons .cons_l .single{float:left;width:50%;overflow:hidden;color:#585C61;font-size:18px;line-height:30px;padding:10px 0;}
.looks .cons .cons_r{float:left;width:30%;margin-right:10%;overflow:hidden;}
.looks .cons .cons_r img{width:150px;display:block;border:solid 5px #fff;}
.looks .cons .cons_r span{display:block;width:100%;text-align:center;color:#507AF9;font-size:16px;margin-top:10px;}
.looks .cons .cons_r .img_infor{width:160px;display:block;margin:10px auto;display:flex;flex-wrap:wrap;}
</style>